import { gql } from 'graphql-request';

const contact = gql`
  mutation contact(
    $name: String!
    $email: String!
    $phone: String
    $hostname: String!
    $formId: Int!
    $extraFields: GenericScalar
  ) {
    contact(
      input: {
        name: $name,
        email: $email,
        phone: $phone,
        hostname: $hostname,
        formId: $formId,
        extraFields: $extraFields,
      }
    ) {
      errors {
        field
        messages
      }
    }
  }
`;

export default contact;
